// These are all the required getters and setters to work with p-table
// you can see/play with this p-table in the pulse test playground page

export const state = () => ({ // maybe change some of these to choose your own default values
  page: 1,
  data: [],
  filters: '',
  headers: [ // definitely change these, they are the column headers
    { text: 'Make & Model', value: 'manufacturer', sortable: false },
    { text: 'Color', value: 'color', sortable: false },
    { text: 'R2B Contract Length', value: 'agreement_length_weeks', sortable: false },
    { text: 'R2B Weekply Price', value: 'agreement_value_weeks', sortable: false },
    { text: 'Total Price', value: 'total_due', sortable: false },
    { text: 'Rental Price', value: 'rental_value', sortable: false },
    { text: 'Action', value: 'action', sortable: false },
  ],
  sortBy: undefined,
  sortDesc: undefined,
  totalResults: undefined,
  itemsPerPage: undefined,
});

export const getters = {
  getData(state) {
    return state.data;
  },
  getPage(state) {
    return state.page;
  },
  getHeaders(state) {
    return state.headers;
  },
  getTotalResults(state) {
    return state.totalResults;
  },
  getItemsPerPage(state) {
    return state.itemsPerPage;
  },
};

export const mutations = {
  setData(store, payload) {
    store.data = payload;
  },
  setPage(store, payload) {
    store.page = payload;
  },
  setFilters(store, payload) {
    store.filters = payload;
  },
  setTotalResults(state, value) {
    state.totalResults = value;
  },
  setSortBy(state, value) {
    state.sortBy = value;
  },
  setSortDesc(state, value) {
    state.sortDesc = value;
  },
  setItemsPerPage(state, value) {
    state.itemsPerPage = value;
  },
};

export const actions = {
  clearData({ commit }) {
    commit('clearData');
  },
  setPage({ commit }, payload) {
    commit('setPage', payload);
  },
  setFilters({ commit }, payload) {
    commit('setFilters', payload);
  },
  setSortBy({ commit }, value) {
    commit('setSortBy', value);
  },
  setSortDesc({ commit }, value) {
    commit('setSortDesc', value);
  },
  setItemsPerPage({ commit }, value) {
    commit('setItemsPerPage', value);
  },
  async loadPage({ commit, state }) {
    let url = '/vehicle_type'; // change this
    url += `?page=${state.page - 1}`;

    if (state.filters) url += state.filters;
    if (state.itemsPerPage !== undefined) url += `&results=${state.itemsPerPage}`;

    const data = await this.$axios.$get(url);
    // const data = MOCK_DATA;

    commit('setData', data.vehicle_type_list);
    commit('setTotalResults', data.total);
  },
};
